import { DecimalPipe } from '@angular/common';
import { AfterViewInit, Component, Input } from '@angular/core';
import { ChartDataSets, ChartOptions, ChartType } from 'chart.js';
import { Chart } from 'chart.js';

@Component({
  selector: 'gender-split-histogram',
  template: `
    <div style="display: block;">
      <canvas id="genderSplitHistogramChart"></canvas>
    </div>
  `,
  styleUrls: ['./gender-split-histogram.component.scss'],
  providers: [DecimalPipe]
})
export class GenderSplitHistogramComponent implements AfterViewInit {
  @Input() barChartLabels: string[];
  @Input() barChartData: ChartDataSets[];

  chart: Chart;

  constructor(private decimalPipe: DecimalPipe) {
    
  }

  ngAfterViewInit() {
    this.createChart();
  }

  createChart() {
    const largestValue = Math.max(...(this.barChartData[0].data as number[]), ...(this.barChartData[1].data as number[]))
    const maxXValue = Math.ceil((largestValue + 10) / 10) * 10;

    this.chart = new Chart("genderSplitHistogramChart", {
      type: 'horizontalBar',
      data: {
        labels: this.barChartLabels,
        datasets: this.barChartData
      },
      options: {
        responsive: true,
        scales: {
          xAxes: [{
            ticks: {
              beginAtZero: true,
              max: maxXValue
            },
            gridLines: {
              display: false
            }
          }],
          yAxes: [{
            gridLines: {
              display: false
            }
          }]
        },
        legend: {
          display: false
        },
        plugins: {
          datalabels: {
            anchor: 'end',
            align: 'end',
            color: (context) => {
              const dataIndex = context.dataIndex;
              const datasetIndex = context.datasetIndex;
              const dataset = context.chart.data.datasets[datasetIndex];
              const value = dataset.data[dataIndex];
              const color = (dataset.label === 'Female') ? '#d091b5' : '#56b3e3';
              return color;
            },
            formatter: (value, context) => {
              return this.formatNumber(value) + '%';
            }
          }
        },
      }
    });
  }

  // Function to format a number using decimal separator and thousands separator
  formatNumber(value: number): string {
    return this.decimalPipe.transform(value, '1.0-1').replace('.', '|').replace(',', '.').replace('|', ',');
  }
}


// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/dashboard/gender-split-histogram/gender-split-histogram.component.ts